const locale = {
  // Options
  items_per_page: '/ oldal',
  // '/ page',
  jump_to: 'Ugrás',
  // 'Goto',
  jump_to_confirm: 'megerősít',
  // 'confirm',
  page: '',
  // Pagination
  prev_page: 'Előző oldal',
  // 'Previous Page',
  next_page: 'Következő oldal',
  // 'Next Page',
  prev_5: 'Előző 5 oldal',
  // 'Previous 5 Pages',
  next_5: 'Következő 5 oldal',
  // 'Next 5 Pages',
  prev_3: 'Előző 3 oldal',
  // 'Previous 3 Pages',
  next_3: 'Következő 3 oldal',
  // 'Next 3 Pages',
  page_size: 'Page Size'
};
export default locale;